import { Model } from "@vuex-orm/core"
import { notify } from "@/services/notification"

export default class Education extends Model {
  static get entity() {
    return "educations"
  }

  static fields() {
    return {
      id: this.attr(null),
      student_id: this.attr(null),
      year_end: this.attr(null),
      year_start: this.attr(null),
      duration: this.attr(""),
      study_type: this.attr(""),
      establishment: this.attr(""),
      certificate_issued: this.attr(""),
      country: this.attr(""),
      is_equivalence: this.attr(null),
    }
  }

  static get possibleStudyTypes() {
    return ["Primaire obligatoire", "Secondaire obligatoire", "Secondaire supérieur", "Universitaire"]
  }

  static async getOneByStudentId(student_id) {
    return await this.api().get(`/student_education/${student_id}`, { dataKey: "data" })
  }

  static async createOne(createdEducation) {
    return await this.api()
      .post(`/student_education`, createdEducation)
      .then(() => {
        notify("success", "Sauvegardé")
      })
      .catch((error) => {
        notify("error", error.response.data.error || error.response.data)
      })
  }

  static async updateOne(updatedEducation) {
    return await this.api()
      .put(`/student_education`, updatedEducation, {
        dataKey: "data",
      })
      .then(() => {
        notify("success", "Sauvegardé")
      })
      .catch((error) => {
        notify("error", error.response.data.error || error.response.data)
      })
  }

  static async deleteOne(id) {
    return await this.api().delete(`/student_education/${id}`, {
      delete: id,
    })
  }
}
